import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from "../../services/http-client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { WebClientService } from "../../services/webclient-settings.service";
import { AuthService } from "../../services/auth.service";
let LimitExceededModalComponent = class LimitExceededModalComponent {
    constructor(httpClient, sanitizer, router, location, themeService, webSettingsService, auth) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.backColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() { }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.router.navigateByUrl('/');
        this.modal.destroy();
    }
    goToVerification() {
        this.close();
        this.router.navigateByUrl('/verify');
    }
};
LimitExceededModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: AuthService }
];
LimitExceededModalComponent = __decorate([
    Component({
        selector: 'app-limit-exceeded-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./limit-exceeded-modal.component.html")).default,
    })
], LimitExceededModalComponent);
export { LimitExceededModalComponent };
